module.exports = __webpack_public_path__ + "img/order-N.b18bd9eb.png";